import { render, staticRenderFns } from "./DepartmentAddUser.vue?vue&type=template&id=2e6b6ae8&scoped=true&lang=pug&"
import script from "./DepartmentAddUser.vue?vue&type=script&lang=js&"
export * from "./DepartmentAddUser.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentAddUser.vue?vue&type=style&index=0&id=2e6b6ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b6ae8",
  null
  
)

export default component.exports